<div matRipple class="as-brochure-container as-pointer" [lazyLoad]="brochure?.image"
    (click)="downloadBrochure(brochure?.document)">
</div>